import { request } from "./client";
import type { ManualOrdVerificationCommand, OrdProductionGate, OrdRecord } from "./types";

const versionBase = (creativeVersionId: string) => `/admin/v1/ord/creative-versions/${creativeVersionId}`;

export const ord = {
  gate: (creativeVersionId: string) =>
    request<OrdProductionGate>(`${versionBase(creativeVersionId)}/gate`),
  manuallyVerify: (creativeVersionId: string, command: ManualOrdVerificationCommand) =>
    request<OrdRecord>(`${versionBase(creativeVersionId)}/manual-verification`, {
      method: "POST",
      body: command,
      csrf: true,
    }),
};
